<template>
    <div class="row">
        <div class="col-12 d-flex justify-content-around figure">
          <VueSvgGauge
              :end-angle="90"
              :gauge-color="[{ offset: 0, color: '#e55039'}, {offset: 30, color: '#fa983a'}, { offset: 70, color: '#b8e994'}]"
              :max="100"
              :min="0"
              :scale-interval="0"
              :separator-step="0"
              :start-angle="-90"
              style="width: 20%"
              v-bind:value="online.length/(online.length+offline.length)*100"
            />
            <div class="text d-flex flex-column justify-content-center align-items-center">
                <span>
                    <span class="number">{{ online.length}}</span>
                    <span class="total">/{{ online.length + offline.length }}</span>
                </span>
                <span class="legend">{{ $t('monitoring.online_equipments') }}</span>
            </div>
        </div>
        <hr/>
        <div class="card col-md-4 col-12 mt-4">
            <div class="card-header ">
              {{ $t('monitoring.online') }}
            </div>
            <div class="row ml-2 mt-2">
                <div class="col-md-6 col-6" v-for="equipment in online">
                    <div class="d-flex w-100 justify-content-left">
                        <i class="fas fa-circle text-success fa-fw"></i>
                      <p class="ml-4"><a
                          v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                        ({{ equipment.company.name }})</a></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card col-md-4 col-12 mt-4">
            <div class="card-header ">
              {{ $t('monitoring.offline') }}
            </div>
            <div class="row ml-2 mt-2">
              <div class="col-md-6 col-6" v-for="equipment in offline">
                <div class="d-flex w-100 justify-content-left">
                  <i class="fas fa-circle text-danger fa-fw"></i>
                  <p class="ml-4"><a
                      v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                    ({{ equipment.company.name }})</a></p>
                </div>
              </div>
            </div>
        </div>
      <div class="card col-md-4 col-12 mt-4">
        <div class="card-header ">
          {{ $t('monitoring.disconnected') }}
        </div>
        <div class="row ml-2 mt-2">
          <div v-for="equipment in disconnected" class="col-md-6 col-6">
            <div class="d-flex w-100 justify-content-left">
              <i v-if="new Date().getTime() - new Date(equipment.last_seen_at).getTime() > 65000 || equipment.last_seen_at == null"
                 class="fas fa-circle text-danger fa-fw"></i>
              <i v-else class="fas fa-circle text-success fa-fw"></i>
              <p class="ml-4"><a
                  v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                ({{ equipment.company.name }})</a></p>
            </div>
          </div>
        </div>
      </div>

      <div class="card col-md-4 col-12 mt-4">
        <div class="card-header ">
          {{ $t('monitoring.unknown') }}
        </div>
        <div class="row ml-2 mt-2">
          <div v-for="equipment in unknown" class="col-md-6 col-6">
            <div class="d-flex w-100 justify-content-left">
              <i v-if="new Date().getTime() - new Date(equipment.last_seen_at).getTime() > 65000 || equipment.last_seen_at == null"
                 class="fas fa-circle text-danger fa-fw"></i>
              <i v-else class="fas fa-circle text-success fa-fw"></i>
              <p class="ml-4"><a
                  v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                ({{ equipment.company.name }})</a></p>
            </div>
          </div>
        </div>
      </div>

      <div class="card col-md-4 col-12 mt-4">
        <div class="card-header ">
          {{ $t('monitoring.under_surveillance') }}
        </div>
        <div class="row ml-2 mt-2">
          <div v-for="equipment in under_surveillance" class="col-md-6 col-6">
            <div class="d-flex w-100 justify-content-left">
              <i v-if="new Date().getTime() - new Date(equipment.last_seen_at).getTime() > 65000 || equipment.last_seen_at == null"
                 class="fas fa-circle text-danger fa-fw"></i>
              <i v-else class="fas fa-circle text-success fa-fw"></i>
              <p class="ml-4"><a
                  v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                ({{ equipment.company.name }})</a></p>
            </div>
          </div>
        </div>
      </div>

      <div class="card col-md-4 col-12 mt-4">
        <div class="card-header ">
          {{ $t('monitoring.testing') }}
        </div>
        <div class="row ml-2 mt-2">
          <div v-for="equipment in testing" class="col-md-6 col-6">
            <div class="d-flex w-100 justify-content-left">
              <i v-if="new Date().getTime() - new Date(equipment.last_seen_at).getTime() > 65000 || equipment.last_seen_at == null"
                 class="fas fa-circle text-danger fa-fw"></i>
              <i v-else class="fas fa-circle text-success fa-fw"></i>
              <p class="ml-4"><a
                  v-bind:href="'/admin/equipments/' + equipment.id">{{ equipment.denomination }}
                ({{ equipment.company.name }})</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import {VueSvgGauge} from 'vue-svg-gauge'

export default {
  data: function () {
    return {
      equipments: [],
      online: [],
      offline: [],
      under_surveillance: [],
      testing: [],
      unknown: [],
      disconnected: []
    }
  },
  mounted() {
    axios.post('/admin/equipments/json', {})
        .then(response => {
                    this.equipments = response.data;
                    setInterval(this.sortEquipments, 1000);
                });
            Echo.private(`monitoring`)
                .listen("EquipmentHandshake", (e) => {
                    this.equipments.forEach((item, index) => {
                        if (item.id === e.equipment.id) {
                            this.equipments[index] = e.equipment;
                        }
                    });
                })
        },
        methods: {
            sortEquipments: function () {
              var online = [];
              var offline = [];
              var testing = [];
              var under_surveillance = [];
              var unknown = [];
              var disconnected = [];
              var now = new Date();
              this.equipments.forEach(function (item) {
                if (item.ip == null) return;
                if (item.status === "online") {
                  if (now.getTime() - new Date(item.last_seen_at).getTime() > 65000 || item.last_seen_at == null) {
                    offline.push(item);
                  } else {
                    online.push(item);
                  }
                } else if (item.status === "under_surveillance") {
                  under_surveillance.push(item);
                } else if (item.status === "testing") {
                  testing.push(item);
                } else if (item.status === "offline") {
                  disconnected.push(item);
                } else {
                  unknown.push(item);
                }

              }.bind(this));
              this.online = online;
              this.offline = offline;
              this.testing = testing;
              this.under_surveillance = under_surveillance;
              this.unknown = unknown;
              this.disconnected = disconnected;
            }
        },
        components: {
            VueSvgGauge
        }
    }
</script>

<style scoped>

    .figure .number {
        font-size: 4em;
    }

    .figure .total {
        font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    }

    .figure .legend {

    }
</style>